import React from 'react'

import styles from './_.module.css'

export const Footer: React.FC = () => {
  const today = new Date()

  return (
    <footer className={styles.footer}>
      <span>
        &copy;{today.getFullYear()} Pepper Content Pvt. Ltd. All Rights
        Reserved.
      </span>
    </footer>
  )
}
